import { escapeHtml } from "../util/escape-html.js";
export class NodeErrorElement extends HTMLElement {
    #message = "This stage could not be opened.";
    connectedCallback() {
        this.render();
    }
    set message(value) {
        this.#message = value;
        this.render();
    }
    render() {
        this.innerHTML = `
      <section class="node-card node-error" data-stage-error role="alert">
        <h2 class="node-card-title">Stage unavailable</h2>
        <p>${escapeHtml(this.#message)}</p>
      </section>
    `;
    }
}
//# sourceMappingURL=node-error.js.map